import classnames from 'classnames';
import styles from './style.module.scss';
import FullScreenContainer from '../../fullScreenContainer';
import FadeIn from '../fadeIn';
import { Element } from 'react-scroll';
import { src } from '../../../utils/common';
import { WebPNativeImage } from '../../WebPImage';

const Architecture = ({
  data,
  isNav = false,
  elementName = '',
  bgColor = '#f8f9fa',
}) => {
  return (
    <Element name={elementName}>
      <main
        className={classnames({
          [styles.container]: true,
          [styles.isNav]: isNav,
        })}
        style={{ backgroundColor: bgColor }}
      >
        <div className={styles.title}>{data.title}</div>
        <div className={styles['pc-wrapper']}>
          <FullScreenContainer picUrl={data.picUrl} />
        </div>
        <div className={styles['mobile-wrapper']}>
          <WebPNativeImage
            src={src(data.picUrl)}
            className={styles['mobile-img']}
          />
        </div>
      </main>
    </Element>
  );
};

export default Architecture;
